<div class="p-4">
  <mat-card class="p-6">
    @if (countriesLoading()) {
      <div class="flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (countriesError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else {
      <h2 class="text-xl mb-6 font-medium">Add New Client</h2>

      <form [formGroup]="clientForm" (ngSubmit)="onSubmit()">
        <!-- Company -->
        <div class="mb-6">
          <mat-form-field class="w-full">
            <mat-label>Company</mat-label>
            <input matInput formControlName="company" required />
            @if (clientForm.get('company')?.hasError('required')) {
              <mat-error>Company is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <!-- First Name -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" required />
              @if (clientForm.get('firstName')?.hasError('required')) {
                <mat-error>First Name is required</mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Last Name -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" required />
              @if (clientForm.get('lastName')?.hasError('required')) {
                <mat-error>Last Name is required</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <!-- Email -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" required />
              @if (clientForm.get('email')?.hasError('required')) {
                <mat-error>Email is required</mat-error>
              }
              @if (
                clientForm.get('email')?.hasError('email') &&
                !clientForm.get('email')?.hasError('required')
              ) {
                <mat-error>Please enter a valid email address</mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Secondary Email -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Secondary Email</mat-label>
              <input matInput type="email" formControlName="secondaryEmail" />
              @if (
                clientForm.get('secondaryEmail')?.hasError('email') &&
                !clientForm.get('secondaryEmail')?.hasError('required')
              ) {
                <mat-error>Please enter a valid email address</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <!-- Phone -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Primary Phone</mat-label>
              <input matInput formControlName="primaryPhone" />
            </mat-form-field>
          </div>

          <!-- Secondary Phone -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Secondary Phone</mat-label>
              <input matInput formControlName="secondaryPhone" />
            </mat-form-field>
          </div>
        </div>

        <!-- Fax Number -->
        <div class="mb-6">
          <mat-form-field class="w-full">
            <mat-label>Fax</mat-label>
            <input matInput formControlName="fax" />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <!-- Terms -->
          <div class="flex flex-col">
            <label class="block mb-2">Terms</label>
            <mat-radio-group formControlName="terms" class="flex flex-wrap gap-4">
              <mat-radio-button value="NET30">NET30</mat-radio-button>
              <mat-radio-button value="COD">COD</mat-radio-button>
              <mat-radio-button value="CIA">CIA</mat-radio-button>
              <mat-radio-button value="CC">CC</mat-radio-button>
              <mat-radio-button value="Other">Other</mat-radio-button>
            </mat-radio-group>
          </div>

          <!-- Credit Info -->
          <div class="flex flex-col">
            <label class="block mb-2">Credit Info Required</label>
            <mat-radio-group formControlName="creditInfo" class="flex gap-4">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Address Section -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <!-- Address 1 -->
          <div class="border p-4 rounded">
            <h3 class="text-lg mb-4">Address 1:</h3>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Type</mat-label>
                <input matInput formControlName="address1Type" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Customer Code</mat-label>
                <input matInput formControlName="customerCode1" required />
                @if (clientForm.get('customerCode1')?.hasError('required')) {
                  <mat-error>Customer Code is required</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Street Address</mat-label>
                <textarea matInput formControlName="address1Street" required></textarea>
                @if (clientForm.get('address1Street')?.hasError('required')) {
                  <mat-error>Street Address is required</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Street Details</mat-label>
                <input matInput formControlName="address1StreetDetails" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>City</mat-label>
                <input matInput formControlName="address1City" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="address1Zip" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Country</mat-label>
                <mat-select formControlName="address1Country">
                  <mat-option [value]="''">None</mat-option>
                  @for (country of countries(); track country.id) {
                    <mat-option [value]="country">{{ country.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (showAddress1StateSelection()) {
                <mat-form-field class="w-full mt-4">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="address1State">
                    @for (state of statesForAddress1(); track state.id) {
                      <mat-option [value]="state.name">{{ state.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }

              @if (showAddress1StateInput()) {
                <mat-form-field class="w-full mt-4">
                  <mat-label>State</mat-label>
                  <input matInput formControlName="address1State" />
                </mat-form-field>
              }
            </div>
          </div>

          <!-- Address 2 -->
          <div class="border p-4 rounded">
            <h3 class="text-lg mb-4">Address 2:</h3>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Type</mat-label>
                <input matInput formControlName="address2Type" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Customer Code</mat-label>
                <input matInput formControlName="customerCode2" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Street Address</mat-label>
                <textarea matInput formControlName="address2Street"></textarea>
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Street Details</mat-label>
                <input matInput formControlName="address2StreetDetails" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>City</mat-label>
                <input matInput formControlName="address2City" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="address2Zip" />
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field class="w-full">
                <mat-label>Country</mat-label>
                <mat-select formControlName="address2Country">
                  <mat-option [value]="''">None</mat-option>
                  @for (country of countries(); track country.id) {
                    <mat-option [value]="country">{{ country.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (showAddress2StateSelection()) {
                <mat-form-field class="w-full mt-4">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="address2State">
                    @for (state of statesForAddress2(); track state.id) {
                      <mat-option [value]="state.name">{{ state.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }

              @if (showAddress2StateInput()) {
                <mat-form-field class="w-full mt-4">
                  <mat-label>State</mat-label>
                  <input matInput formControlName="address2State" />
                </mat-form-field>
              }
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-4">
          <button
            type="button"
            mat-flat-button
            (click)="onCancel()"
            [disabled]="isCreatingClient()"
          >
            CANCEL
          </button>
          <button
            type="submit"
            mat-flat-button
            color="primary"
            [disabled]="clientForm.invalid || isCreatingClient()"
          >
            CREATE CLIENT
          </button>
        </div>
      </form>
    }
  </mat-card>
</div>
